import CreateGLCodeContainer from "./CreateGLCodeContainer";
export default CreateGLCodeContainer;
